class randomBorderradius {
    private static image_COUNT = 0;
    private image_SPEED = 10;
    private min = 10;
    private max = 50;

    private readonly imageId: number;
    private element: HTMLElement;

    constructor(element: HTMLElement) {
        this.imageId = randomBorderradius.image_COUNT++;
        this.element = element;

        this.createKeyframe();
    }

    randomInt() { // min and max included
        return Math.floor(Math.random() * (this.max - this.min + 1) + this.min)
    }

    createKeyframe() {
        const style = document.createElement('style');
        style.setAttribute('type', 'text/css')
        let keyFrames = `
            @keyframes image_NAME {
                  0%, 100% {
                    border-radius: R_LOWpx R_MIDpx R_MIDpx R_LOWpx;
                  }
                  34% {
                    border-radius: R_HIGHpx R_LOWpx R_MIDpx R_MIDpx;
                  }
                  67% {
                    border-radius: R_HIGHpx R_MIDpx R_MIDpx R_HIGHpx;
                  } 
            }
        `;

        keyFrames = keyFrames.replace(/R_LOW/g, () => this.randomInt().toString());
        keyFrames = keyFrames.replace(/R_MID/g, () => this.randomInt().toString());
        keyFrames = keyFrames.replace(/R_HIGH/g, () => this.randomInt().toString());
        keyFrames = keyFrames.replace(/image_NAME/g, "image-" + this.imageId);

        style.innerHTML = keyFrames;
        document.getElementsByTagName('head')[0].appendChild(style);

        this.element.style.animation = `image-${this.imageId} ${this.image_SPEED}s ease-in-out infinite`;
    }
}